// extracted by mini-css-extract-plugin
export default {"title":"CreateVolunteersSmartGroup_title__rTU5x","actions":"CreateVolunteersSmartGroup_actions__C9Ofj"};